import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from '@react-pdf/renderer';

import hgsdLogo from '../black-textHGSDlogo400px.png';
import ftBendLogo from '../fbsd_logo_clr_rgb.png';
import ReportBuilder from './ReportBuilder';
import AppendixA from './report/AppendixA';
import AppendixB from './report/AppendixB';
import AppendixC from './report/AppendixC';
import AppendixD from './report/AppendixD';
import AppendixE from './report/AppendixE';
import AppendixF from './report/AppendixF';
import AppendixG from './report/AppendixG';
import AppendixH from './report/AppendixH';
import AppendixI from './report/AppendixI';
import AppendixJ from './report/AppendixJ';

const MONTHS = [
  '',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: require('../fonts/Roboto-Regular.ttf'),
    },
    {
      src: require('../fonts/Roboto-Bold.ttf'),
      fontWeight: 700,
    },
  ],
});

const styles = StyleSheet.create({
  document: {
    padding: 20,
    fontSize: 12,
  },
  pageTitle: {
    marginTop: 5,
    textAlign: 'center',
    fontSize: 10,
  },
  header: {
    flexDirection: 'row',
    paddingBottom: 20,
  },
  cover: {
    flexDirection: 'column',
    paddingTop: 100,
    paddingLeft: 200,
    // textAlign: 'center',
  },
  coverTitle: {
    fontSize: 18,
    fontFamily: 'Roboto',
    fontWeight: 700,
    paddingTop: 20,
    paddingLeft: 40,
  },
  coverLogo: {
    width: 200,
    height: 200,
  },
  logo: {
    width: 40,
    height: 40,
  },
  logoLabel: {
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: 16,
    paddingLeft: 20,
    paddingTop: 10,
  },
  horizontal: {
    flexDirection: 'row',
  },
  vertical: {
    flexDirection: 'column',
    paddingLeft: 5,
    paddingRight: 5,
  },
  headerLabel: {
    fontFamily: 'Roboto',
    fontWeight: 700,
    paddingRight: 10,
  },
  label: {
    paddingRight: 5,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 5,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxWidth: '50%',
  },
  section: {
    marginTop: 20,
    padding: 5,
  },
  border: {
    borderStyle: 'solid',
    borderColor: '#000000',
    borderWidth: 1,
  },
  logoBorderBottom: {
    borderBottomStyle: 'solid',
    borderBottomColor: '#000000',
    borderBottomWidth: 3,
  },
  borderTop: {
    borderTopStyle: 'solid',
    borderTopColor: '#000000',
    borderTopWidth: 1,
  },
  borderBottom: {
    borderBottomStyle: 'solid',
    borderBottomColor: '#000000',
    borderBottomWidth: 1,
  },
  data: {
    textAlign: 'right',
    paddingRight: 20,
  },
  paragraph: {
    paddingLeft: 20,
  },
  footer: {
    bottom: '10pt',
    left: 0,
    position: 'absolute',
    right: 0,
    fontSize: 10,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});

function escapeHTML(text) {
  if (text) {
    return text.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  } else {
    return text;
  }
}

function getCaseNumbers(permittee) {
  // return permittee.caseNumbers.join(', ');
  return permittee.caseNumbers.join('\n');
}

function getLeadWells(permittee) {
  // return permittee.leadWells.join(', ');
  return permittee.leadWells.join('\n');
}

export default function SummaryReport(props) {
  console.log('PrintSummary data:');
  console.log(props.data);
  // const { reportYear, pumpage } = await ReportBuilder.getAnnualReportPumpage(
  //   props.permit
  // );

  return (
    <Document>
      <Page size='A4'>
        <View style={styles.cover}>
          {/* <View style={styles.row}> */}
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.coverLogo}
          />
          {/* </View>
          <View style={styles.row}> */}
          <Text style={styles.coverTitle}>Board Book</Text>
          {/* </View>
          <View style={styles.row}> */}
          <Text style={styles.coverTitle}>{`${MONTHS[props.month]} ${
            props.year
          } `}</Text>
          {/* </View> */}
        </View>
        <View fixed style={styles.footer}>
          {/* <Text style={styles.data}>{`${MONTHS[props.month]} ${
            props.year
          } `}</Text> */}
          <Text
            style={styles.data}
            render={({ pageNumber, totalPages }) =>
              `${MONTHS[props.month]} ${
                props.year
              } (${pageNumber}/${totalPages})`
            }
          />
        </View>
      </Page>
      <Page size='A4'>
        <View style={styles.pageTitle}>
          <Text style={styles.pageTitle}></Text>
        </View>
        <View style={styles.document}>
          <View style={[styles.row, styles.borderBottom]}>
            <Image
              src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
              style={styles.logo}
            />
            <Text style={styles.logoLabel}>Table of Contents</Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>1. Permittees</Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              2. Appendix A - Abbreviations / Acronyms
            </Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              3. Appendix B - Special Provision Description
            </Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>4. Appendix C - Summary</Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              5. Appendix D - Continued Applicants
            </Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              6. Appendix E - Administrative Modifications
            </Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              7. Appendix F - Advertised in Error
            </Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              8. Appendix G - Outcome of Permits Advertised for Cancellation
            </Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              9. Appendix H - Lake Makeup Report
            </Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              10. Appendix I - New Wells Report
            </Text>
          </View>
          <View style={[styles.header, styles.section]}>
            <Text style={styles.headerLabel}>
              11. Appendix J - Take No Action Applications
            </Text>
          </View>
        </View>
        <View fixed style={styles.footer}>
          {/* <Text style={styles.data}>{`${MONTHS[props.month]} ${
            props.year
          } `}</Text> */}
          <Text
            style={styles.data}
            render={({ pageNumber, totalPages }) =>
              `${MONTHS[props.month]} ${
                props.year
              } (${pageNumber}/${totalPages})`
            }
          />
        </View>
      </Page>
      <Page size='A4'>
        <View style={styles.pageTitle}>
          <Text style={styles.pageTitle}></Text>
        </View>
        <View style={styles.document}>
          <View style={[styles.row, styles.borderBottom]}>
            <Image
              src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
              style={styles.logo}
            />
            <Text style={styles.logoLabel}>List of Permits</Text>
          </View>
          <View style={styles.section}>
            <View style={[styles.row, styles.borderBottom]}>
              <Text style={styles.column}>Permittee</Text>
              <Text style={styles.column}>Regulatory Area</Text>
              <Text style={styles.column}>Case Numbers</Text>
              <Text style={styles.column}>Lead Wells</Text>
              <Text style={styles.column}>Provisions</Text>
            </View>
            {props.data.permittees.map((permittee, i) => (
              <View key={i} style={styles.row}>
                <Text style={styles.column}>{permittee.NAME}</Text>
                <Text style={styles.column}>{permittee.AREA}</Text>
                <Text style={styles.column}>{getCaseNumbers(permittee)}</Text>
                {/* <Text style={styles.column}>
                  {permittee.caseNumbers.map((item, index) => (
                    <div key={index}>{item.replace((/-/g, '\u2011'))}</div>
                  ))}
                </Text> */}
                <Text style={styles.column}>{getLeadWells(permittee)}</Text>
                {/* <Text style={styles.column}>
                  {permittee.leadWells.map((item, index) => (
                    <div key={index}>{item}</div>
                  ))}
                </Text> */}
                <Text style={styles.column}>
                  {escapeHTML(permittee.VIOLATIONS)}
                </Text>
              </View>
            ))}
          </View>
        </View>
        <View fixed style={styles.footer}>
          {/* <Text style={styles.data}>{`${MONTHS[props.month]} ${
            props.year
          } `}</Text> */}
          <Text
            style={styles.data}
            render={({ pageNumber, totalPages }) =>
              `${MONTHS[props.month]} ${
                props.year
              } (${pageNumber}/${totalPages})`
            }
          />
        </View>
      </Page>
      {props.data.permittees.map((permittee, i) => (
        <Page size='A4' key={i}>
          <View style={styles.pageTitle}>
            <Text style={styles.pageTitle}>{permittee.NAME}</Text>
          </View>
          <View style={styles.document}>
            <View style={[styles.row, styles.borderBottom]}>
              <Image
                src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
                style={styles.logo}
              />
              <Text style={styles.logoLabel}>Permit Recommendations</Text>
            </View>
            <View style={[styles.header, styles.section]}>
              <Text style={styles.headerLabel}>Permittee:</Text>
              <Text>{permittee.NAME}</Text>
            </View>
            {permittee.permitData.map((permit, j) => (
              <View key={j}>
                <View
                  style={[styles.header, styles.borderBottom, styles.section]}
                >
                  <Text style={styles.headerLabel}>Case Number:</Text>
                  <Text>{permit.CASE_NUMBER}</Text>
                </View>

                <View style={[styles.row, styles.borderBottom, styles.section]}>
                  <View style={styles.column}>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        Lead Well:
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {ReportBuilder.getLeadWellNumber(permit)}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        District Plan Compliance:
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {ReportBuilder.getDistrictPlanCompliance(permit)}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        New Permit Term:
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {ReportBuilder.getTerm(permit)}
                      </Text>
                    </View>
                  </View>
                  <View style={styles.column}>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        Reg. Area:
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {ReportBuilder.getRegArea(permit)}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        {permit.reportYear
                          ? `${permit.reportYear} Annual Report Pumpage:`
                          : 'Annual Report Pumpage:'}
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {permit.pumpage
                          ? permit.pumpage.toFixed(2) + ' MG'
                          : 'NA'}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        Expiring Permit Term:
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {ReportBuilder.getExpiringTerm(permit)}
                      </Text>
                    </View>
                  </View>
                </View>

                <View style={[styles.row, styles.section]}>
                  <View style={styles.column}>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        Prev. 12 mos. Groundwater:
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {`${ReportBuilder.getPrev12MGroundwater(permit)} MG`}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        Prev. 12 mos. Alternate Water:
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {`${ReportBuilder.getPrev12MAlternateWater(permit)} MG`}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        Prev. 12 mos. Total Water Demand:
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {`${
                          ReportBuilder.getPrev12MGroundwater(permit) +
                          ReportBuilder.getPrev12MAlternateWater(permit)
                        } MG`}
                      </Text>
                    </View>
                  </View>
                  <View style={styles.column}>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        {`${
                          permit.termBegin
                            ? `${new Date(
                                permit.termBegin,
                              ).getFullYear()}-${new Date(
                                permit.termEnd,
                              ).getFullYear()}`
                            : 'Previous'
                        } Permit Allocation`}
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {permit.allocation ? permit.allocation + ' MG' : 'NA'}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        {`${ReportBuilder.getTermBeginYear(permit)} Request:`}
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {`${ReportBuilder.getRequestedAmount(permit).toFixed(
                          2,
                        )} MG`}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={[styles.column, styles.label]}>
                        {`${ReportBuilder.getYear(permit)} Recommendation:`}
                      </Text>
                      <Text style={[styles.column, styles.data]}>
                        {`${ReportBuilder.getRecommendationAmount(
                          permit,
                        ).toFixed(2)} MG`}
                      </Text>
                    </View>
                  </View>
                </View>

                {/* <View style={[styles.row, styles.section, styles.border]}>
                  <View style={[styles.column, styles.vertical, { flex: 1 }]}>
                    <Text style={[styles.headerLabel, styles.borderBottom]}>
                      Well
                    </Text>
                    <Text>{ReportBuilder.getLeadWellNumber(permit)}</Text>
                  </View>
                  <View style={[styles.column, styles.vertical, { flex: 2 }]}>
                    <Text style={[styles.headerLabel, styles.borderBottom]}>
                      Term
                    </Text>
                    <Text>{ReportBuilder.getTerm(permit)}</Text>
                  </View>
                  <View style={[styles.column, styles.vertical, { flex: 3 }]}>
                    <Text style={[styles.headerLabel, styles.borderBottom]}>
                      Location
                    </Text>
                    <Text>{ReportBuilder.getLocation(permit)}</Text>
                  </View>
                  <View style={[styles.column, styles.vertical, { flex: 2 }]}>
                    <Text style={[styles.headerLabel, styles.borderBottom]}>
                      Diameter
                    </Text>
                    <Text>{`${permit.diameter}"`}</Text>
                  </View>
                  <View style={[styles.column, styles.vertical, { flex: 2 }]}>
                    <Text style={[styles.headerLabel, styles.borderBottom]}>
                      Status
                    </Text>
                    <Text>{ReportBuilder.getStatus(permit)}</Text>
                  </View>
                </View> */}

                <View
                  style={[
                    { display: 'flex', flexDirection: 'column' },
                    styles.section,
                    styles.border,
                  ]}
                >
                  <View style={{ flexDirection: 'row' }}>
                    <View style={[styles.column, styles.vertical, { flex: 1 }]}>
                      <Text style={styles.headerLabel}>Well</Text>
                    </View>
                    <View style={[styles.column, styles.vertical, { flex: 2 }]}>
                      <Text style={styles.headerLabel}>Term</Text>
                    </View>
                    <View style={[styles.column, styles.vertical, { flex: 3 }]}>
                      <Text style={styles.headerLabel}>Location</Text>
                    </View>
                    <View style={[styles.column, styles.vertical, { flex: 2 }]}>
                      <Text style={styles.headerLabel}>Diameter</Text>
                    </View>
                    <View style={[styles.column, styles.vertical, { flex: 2 }]}>
                      <Text style={styles.headerLabel}>Status</Text>
                    </View>
                  </View>
                  {permit.wells.map((well, w) => (
                    <View
                      key={w}
                      style={[styles.borderTop, { flexDirection: 'row' }]}
                    >
                      <View
                        style={{ paddingLeft: 5, paddingRight: 5, flex: 1 }}
                      >
                        <Text>{well.ASSET_ID}</Text>
                      </View>
                      <View
                        style={{ paddingLeft: 5, paddingRight: 5, flex: 2 }}
                      >
                        <Text>{ReportBuilder.getTerm(permit)}</Text>
                      </View>
                      <View
                        style={{ paddingLeft: 5, paddingRight: 5, flex: 3 }}
                      >
                        <Text>{well.LOCATION}</Text>
                      </View>
                      <View
                        style={{ paddingLeft: 5, paddingRight: 5, flex: 2 }}
                      >
                        <Text>{`${well.diameter}"`}</Text>
                      </View>
                      <View
                        style={{ paddingLeft: 5, paddingRight: 5, flex: 2 }}
                      >
                        <Text>{ReportBuilder.getStatus(permit)}</Text>
                      </View>
                    </View>
                  ))}
                </View>

                {/* <View
                  style={[
                    styles.column,
                    styles.section,
                    styles.border,
                    { flex: 1 },
                  ]}
                >
                  <View style={[styles.row, { flex: 1 }]}>
                    <Text
                      style={[
                        styles.headerLabel,
                        styles.borderBottom,
                        { flex: 1 },
                      ]}
                    >
                      Well
                    </Text>

                    <Text
                      style={[
                        styles.headerLabel,
                        styles.borderBottom,
                        { flex: 2 },
                      ]}
                    >
                      Term
                    </Text>

                    <Text
                      style={[
                        styles.headerLabel,
                        styles.borderBottom,
                        { flex: 3 },
                      ]}
                    >
                      Location
                    </Text>

                    <Text
                      style={[
                        styles.headerLabel,
                        styles.borderBottom,
                        { flex: 2 },
                      ]}
                    >
                      Diameter
                    </Text>

                    <Text
                      style={[
                        styles.headerLabel,
                        styles.borderBottom,
                        { flex: 2 },
                      ]}
                    >
                      Status
                    </Text>
                  </View> */}
                {/* <View style={[styles.row]}>
                    <Text>well.ASSET_ID</Text>
                    <Text>ReportBuilder.getTerm(permit)</Text>
                    <Text>well.LOCATION</Text>
                    <Text>well.diameter</Text>
                    <Text>ReportBuilder.getStatus</Text>
                  </View> */}
                {/* {permit.wells.map((well, w) => (
                    <View key={w} style={[styles.row]}>
                      <View style={[{ flex: 1 }]}>
                        <Text>{well.ASSET_ID}</Text>
                      </View>
                      <View style={[{ flex: 2 }]}>
                        <Text>{ReportBuilder.getTerm(permit)}</Text>
                      </View>
                      <View style={[{ flex: 3 }]}>
                        <Text>{well.LOCATION}</Text>
                      </View>
                      <View style={[{ flex: 2 }]}>
                        <Text>{`${well.diameter}"`}</Text>
                      </View>
                      <View style={[{ flex: 2 }]}>
                        <Text>{ReportBuilder.getStatus(permit)}</Text>
                      </View>
                    </View>
                  ))} */}
                {/* </View> */}

                <View style={[styles.header, styles.section]}>
                  <Text style={styles.headerLabel}>Recommendations:</Text>
                </View>
                <View>
                  {ReportBuilder.getRecommendations(permit).map((note, key) => (
                    <Text key={key}>{`${key + 1}) ${note}`}</Text>
                  ))}
                </View>

                <View style={[styles.header, styles.section]}>
                  <Text style={styles.headerLabel}>
                    Testimony and Findings:
                  </Text>
                </View>
                <View>
                  {ReportBuilder.getTestimony(permit).map((note, key) => (
                    <Text key={key}>{note}</Text>
                  ))}
                </View>
              </View>
            ))}
          </View>
          <View fixed style={styles.footer}>
            {/* <Text style={styles.data}>{`${MONTHS[props.month]} ${props.year} `}</Text> */}
            <Text
              style={styles.data}
              render={({ pageNumber, totalPages }) =>
                `${MONTHS[props.month]} ${
                  props.year
                } (${pageNumber}/${totalPages})`
              }
            />
          </View>
        </Page>
      ))}

      <AppendixA
        styles={styles}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
      <AppendixB styles={styles} />
      <AppendixC
        styles={styles}
        hearing={props.data.hearing}
        year={props.year}
        month={props.month}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
      <AppendixD
        styles={styles}
        data={props.data.continuedApplicants}
        year={props.year}
        month={props.month}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
      <AppendixE
        styles={styles}
        data={props.data.adminModifications}
        year={props.year}
        month={props.month}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
      <AppendixF
        styles={styles}
        data={props.data.advertisedInError}
        year={props.year}
        month={props.month}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
      <AppendixG
        styles={styles}
        data={props.data.cancelled}
        year={props.year}
        month={props.month}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
      <AppendixH
        styles={styles}
        data={props.data.lakeReport}
        year={props.year}
        month={props.month}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
      <AppendixI
        styles={styles}
        data={props.data.newWells}
        year={props.year}
        month={props.month}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
      <AppendixJ
        styles={styles}
        data={props.data.takeNoAction}
        year={props.year}
        month={props.month}
        footer={`${MONTHS[props.month]} ${props.year} `}
      />
    </Document>
  );
}
